export enum MerchantBankStatus {
  'Inactive' = 0,
  'Active',
  'On-Hold'
}
